import { render } from "./UiTextarea.vue?vue&type=template&id=4df0f516"
import script from "./UiTextarea.vue?vue&type=script&lang=js"
export * from "./UiTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__